import React from "react";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Loader } from "../components/ui/loader/loader";
import Login from "../pages/login/login";
const MyRoadmap = lazy(() => import("../pages/athlete/myRoadMap/MyRoadmap"));
const ReturnPolicy = lazy(() => import("../pages/ReturnPolicy"));
const ShippingPolicy = lazy(() => import("../pages/ShippingPolicy"));
const PaymentSuccess = lazy(() => import("../pages/contractor/Payment_Section/PaymentSuccess"));
const CorporatePartner = lazy(() =>
  import("../pages/HomeScreens/CorporatePartner")
);
const AppliedCandidateDetails = lazy(() =>
  import("../pages/business/AppliedCandidateDetails")
);
const ShortlistCandidate = lazy(() =>
  import("../pages/business/ShortlistCandidate")
);
const MyFavorite = lazy(() => import("../pages/athlete/MyFavorite"));
const LABResources = lazy(() => import("../pages/HomeScreens/LabResources"));
const ChatPage = lazy(() => import("../pages/chat/ChatPage"));
const BusinessJobDetails = lazy(() =>
  import("../pages/business/businessJobDetails")
);
const EditAthlete = lazy(() => import("../pages/athlete/EditAthlete"));
const NotificationDetails = lazy(() =>
  import("../pages/notification/NotificationDetails")
);
const NotificationsPage = lazy(() =>
  import("../pages/notification/NotificationsPage")
);
const BlogDetails = lazy(() => import("../pages/HomeScreens/blogDetails"));
const Blog = lazy(() => import("../pages/HomeScreens/blog"));
const Ballerpreneurs = lazy(() =>
  import("../pages/HomeScreens/ballerpreneurs")
);
const AthleteSecurity = lazy(() =>
  import("../pages/athlete/athleteSecurity/athleteSecurity")
);
const AboutUs = lazy(() => import("../pages/HomeScreens/AboutUs"));
const ContactUs = lazy(() => import("../pages/HomeScreens/ContactUs"));
const LabServices = lazy(() => import("../pages/HomeScreens/LabServices"));
const LabApp = lazy(() => import("../pages/HomeScreens/LabApp"));
const Dashboard = lazy(() => import("../pages/dashboard/dashboard"));
const CompanyInfoEdit = lazy(() => import("../pages/business/companyinfoedit"));
const Companyinfo = lazy(() => import("../pages/business/companyinfo"));
const Joblisting = lazy(() => import("../pages/business/joblisting"));
const AddNewJob = lazy(() => import("../pages/business/addNewJob"));
const Support = lazy(() => import("../pages/business/support"));
const Setting = lazy(() => import("../pages/business/setting"));
const Candidates = lazy(() => import("../pages/business/Candidates"));
const PrivacyPolicy = lazy(() => import("../pages/business/PrivacyPolicy"));
const TermsAndConditions = lazy(() =>
  import("../pages/business/termsAndConditions")
);
const FAQ = lazy(() => import("../pages/business/FAQ"));
const WelcomePage = lazy(() =>
  import("../pages/contractor/welcome/welcomePage")
);
const BuildYourProfile = lazy(() =>
  import("../pages/contractor/buildYourProfile/buildYourProfile")
);
const CommonLayout = lazy(() => import("../commonLayout"));
const SubscriptionPlanPage = lazy(() =>
  import("../pages/contractor/subscriptionPlan/subscriptionPlanPage")
);
const SignUp = lazy(() => import("../pages/signUp/signUp"));
const Videouploadpage = lazy(() =>
  import("../pages/contractor/videoupload/videouploadpage")
);
const PaymentPage = lazy(() =>
  import("../pages/contractor/Payment_Section/PaymentPage")
);
const ProfileSetup = lazy(() =>
  import("../pages/contractor/ProfileSetup/ProfileSetup")
);
const WNineForm = lazy(() => import("../pages/contractor/wNineForm/wNineForm"));
const Account = lazy(() => import("../pages/contractor/account/Account"));
const EditAccount = lazy(() =>
  import("../pages/contractor/editAccount/EditAccount")
);
const ContractorSecurity = lazy(() =>
  import("../pages/contractor/contractorSecurity/contractorSecurity")
);
const AthleteInterest = lazy(() => import("../pages/athlete/AthleteInterest"));
const AthleteHistory = lazy(() => import("../pages/athlete/AthleteHistory"));
const AthleteLocation = lazy(() => import("../pages/athlete/AthleteLocation"));
const VerifyCode = lazy(() => import("../pages/forgotPassword/verifyCode"));
const ResetPassword = lazy(() =>
  import("../pages/forgotPassword/resetPassword")
);
const ForgotPassword = lazy(() =>
  import("../pages/forgotPassword/forgotPassword")
);
const Mycareer = lazy(() => import("../pages/athlete/MyCareer"));
const PersonalInfo = lazy(() => import("../pages/athlete/PersonalInfo"));
const HomeTermsandcondition = lazy(() =>
  import("../pages/HomeTerms&condition")
);
const HomeFAQ = lazy(() => import("../pages/HomeFAQ"));
const HomePrivacyPolicy = lazy(() => import("../pages/HomePrivacyPolicy"));
const ThanksWall = lazy(() => import("../pages/ThanksWall"));
const JobDetails = lazy(() => import("../pages/athlete/JobDetails/JobDetails"));
const MyResources = lazy(() =>
  import("../pages/athlete/MyResources/MyResources")
);
const CoachDetails = lazy(() =>
  import("../pages/athlete/CoachDetails/CoachDetails")
);
const AthleteProfileSetup = lazy(() =>
  import("../pages/athlete/AthleteProfileSetup")
);
const AthleteSupport = lazy(() =>
  import("../pages/athlete/athleteSupport/AthleteSupport")
);
const AppRoutes = () => {
  const routeList = [
    {
      path: "/",
      element: <Dashboard />,
      exact: true,
      layout: false,
    },
    {
      path: "/home",
      element: <Dashboard />,
      exact: true,
      layout: false,
    },
    {
      path: "/login",
      element: <Login />,
      exact: false,
      layout: false,
    },
    {
      path: "/forgot-password",
      element: <ForgotPassword />,
      exact: true,
      layout: false,
    },
    {
      path: "/verify-otp",
      element: <VerifyCode />,
      exact: true,
      layout: false,
    },
    {
      path: "/forgot-password/verify-code",
      element: <VerifyCode />,
      exact: true,
      layout: false,
    },
    {
      path: "/forgot-password/reset-password",
      element: <ResetPassword />,
      exact: true,
      layout: false,
    },
    {
      path: "/business/edit",
      element: <CompanyInfoEdit />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/info",
      element: <Companyinfo />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/job",
      element: <Joblisting />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/candidates",
      element: <Candidates />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/job/:id?",
      element: <AddNewJob />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/support",
      element: <Support />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/setting",
      element: <Setting />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/setting/privacypolicy",
      element: <PrivacyPolicy />,
      exact: true,
      layout: true,
    },
    {
      path: "/privacypolicy",
      element: <HomePrivacyPolicy />,
      exact: true,
      layout: false,
    },
    {
      path: "/return-policy",
      element: <ReturnPolicy />,
      exact: true,
      layout: false,
    },
    {
      path: "/shipping-policy",
      element: <ShippingPolicy />,
      exact: true,
      layout: false,
    },
    {
      path: "/thankswall",
      element: <ThanksWall />,
      exact: true,
      layout: false,
    },
    {
      path: "/team",
      element: <AboutUs />,
      exact: true,
      layout: false,
    },
    {
      path: "/ballerpreneurs",
      element: <Ballerpreneurs />,
      exact: true,
      layout: false,
    },
    {
      path: "/blog",
      element: <Blog />,
      exact: true,
      layout: false,
    },
    {
      path: "/blog/:id",
      element: <BlogDetails />,
      exact: true,
      layout: false,
    },
    {
      path: "/contactus",
      element: <ContactUs />,
      exact: true,
      layout: false,
    },
    {
      path: "/corporatepartnership",
      element: <CorporatePartner />,
      exact: true,
      layout: false,
    },
    {
      path: "/services",
      element: <LabServices />,
      exact: true,
      layout: false,
    },
    {
      path: "/globall-pass",
      element: <LabApp />,
      exact: true,
      layout: false,
    },

    {
      path: "/business/setting/terms&conditions",
      element: <TermsAndConditions />,
      exact: true,
      layout: true,
    },
    {
      path: "/terms&conditions",
      element: <HomeTermsandcondition />,
      exact: true,
      layout: false,
    },
    {
      path: "/business/setting/FAQ",
      element: <FAQ />,
      exact: true,
      layout: true,
    },
    {
      path: "/faq",
      element: <HomeFAQ />,
      exact: true,
      layout: false,
    },
    {
      path: "/welcome",
      element: <WelcomePage />,
      exact: true,
      layout: false,
    },
    {
      path: "/buildyourprofile",
      element: <BuildYourProfile />,
      exact: true,
      layout: false,
    },
    {
      path: "/signup",
      element: <SignUp />,
      exact: true,
      layout: false,
    },
    {
      path: "/plan",
      element: <SubscriptionPlanPage />,
      exact: true,
      layout: false,
    },
    {
      path: "/contractor/videoupload",
      element: <Videouploadpage />,
      exact: true,
      layout: true,
    },
    {
      path: "/plan/makepayment",
      element: <PaymentPage />,
      exact: true,
      layout: true,
    },
    {
      path: "/contractor/profile",
      element: <ProfileSetup />,
      exact: true,
      layout: false,
    },
    {
      path: "/contractor/profile/w-9",
      element: <WNineForm />,
      exact: true,
      layout: true,
    },
    {
      path: "/profile",
      element: <AthleteProfileSetup />,
      exact: true,
      layout: false,
    },
    {
      path: "/location",
      element: <AthleteLocation />,
      exact: true,
      layout: false,
    },
    {
      path: "/interest",
      element: <AthleteInterest />,
      exact: true,
      layout: false,
    },
    {
      path: "/history",
      element: <AthleteHistory />,
      exact: true,
      layout: false,
    },
    {
      path: "/athlete/mycareer",
      element: <Mycareer />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/personal-info",
      element: <PersonalInfo />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/mycareer/jobdetails",
      element: <JobDetails />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/myresources",
      element: <MyResources />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/myresources/coachdetails",
      element: <CoachDetails />,
      exact: true,
      layout: true,
    },

    {
      path: "/contractor/Account",
      element: <Account />,
      exact: true,
      layout: true,
    },
    {
      path: "/contractor/account/edit",
      element: <EditAccount />,
      exact: true,
      layout: true,
    },
    {
      path: "/contractor/security",
      element: <ContractorSecurity />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/support",
      element: <AthleteSupport />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/security",
      element: <AthleteSecurity />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/personal-info/edit",
      element: <EditAthlete />,
      exact: true,
      layout: true,
    },
    {
      path: "/contractor/notification/:id",
      element: <NotificationDetails />,
      exact: true,
      layout: false,
    },
    {
      path: "/contractor/notifications",
      element: <NotificationsPage />,
      exact: true,
      layout: true,
    },
    {
      path: "/chat",
      element: <ChatPage />,
      exact: true,
      layout: false,
    },
    {
      path: "/business/job-detail/:id",
      element: <BusinessJobDetails />,
      exact: true,
      layout: true,
    },
    {
      path: "/resources",
      element: <LABResources />,
      exact: true,
      layout: false,
    },
    {
      path: "/athlete/my-favorite",
      element: <MyFavorite />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/candidates/:id",
      element: <AppliedCandidateDetails />,
      exact: true,
      layout: true,
    },
    {
      path: "/business/shortlisted-candidates",
      element: <ShortlistCandidate />,
      exact: true,
      layout: true,
    },
    {
      path: "/plan/makepayment/payment-success",
      element: <PaymentSuccess />,
      exact: true,
      layout: true,
    },
    {
      path: "/athlete/myroadmap",
      element: <MyRoadmap />,
      exact: true,
      layout: true,
    },
  ];

  return (
    <Suspense fallback={<Loader />}>
      {/* <Router> */}
        <Routes>
          {routeList.map(({ path, element, layout }) => (
            <Route
              key={path}
              path={path}
              element={
                layout ? <CommonLayout>{element}</CommonLayout> : element
              }
            />
          ))}
        </Routes>
      {/* </Router> */}
    </Suspense>
  );
};

export default AppRoutes;
